<template>
  <div class="sidebar" @click="handelPackUpBtn" :class="{ 'sidebar-fold': isPackUp }" @mouseenter="showSidebar"
    @mouseleave="showSidebar">
    <img :src="unfoldSrc" v-if="show && !isPackUp" />
    <img :src="foldSrc" v-if="show && isPackUp" />
  </div>
</template>

<script>
export default {
  name: "sidebar",
  data() {
    return {
      show: false,
      unfoldSrc: null,
      foldSrc: null
    };
  },
  computed: {
    isPackUp() {
      return this.$store.getters.isPackUp;
    },
  },
  mounted() {
    const theme = document.querySelector('html').getAttribute("data-theme") ?? 'blue';
    if (theme.toLocaleLowerCase() == 'blue') {
      this.unfoldSrc = require('@/svg/unfold.svg');
      this.foldSrc = require('@/svg/fold.svg')
    }else{
      this.unfoldSrc = require('@/svg/unfold_orange.svg');
      this.foldSrc = require('@/svg/fold_orange.svg')
    }
  },
  methods: {
    handelPackUpBtn() {
      this.$store.commit("SET_ISPACKUP", !this.isPackUp);
      // let container = document.getElementById("app");
      // console.log(container, "container")
      // let anchorContainer = document.getElementById('container')
      // console.log(anchorContainer, "anchorContainer")
      //  container.scrollLeft = anchorContainer.clientWidth();
      // console.log(anchorContainer, "scrollLeft" )
    },
    showSidebar() {
      this.show = !this.show;
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  position: absolute;
  top: 100px;
  right: -11px;
  z-index: 100;
  cursor: pointer;
  height: calc(100% - 305px);
  width: 12px;
  display: flex;
  align-items: center;

  img {
    width: 12px;
    height: 56px;
  }
}

.sidebar-fold {
  right: 0;
}
</style>
